import * as React from 'react'
import { isShortenedDomainUrl } from '@disco/utils/hostnames'
import ShortlinkNotFound from 'pages/shortlink-not-found'
import { BriefNotFound } from 'features/briefs/pages/not-found'
import NotFoundPage from 'components/not-found-page'

export default function NotFound(): React.ReactElement | React.ReactNode {
  if (isShortenedDomainUrl()) {
    return <ShortlinkNotFound />
  }

  if (window.location.pathname.startsWith('/brief/')) {
    return <BriefNotFound />
  }

  return <NotFoundPage />
}
